import { useCallback, useEffect, useRef, useState } from "react";
import { WIDGET_ID } from '../config/constants';
export function useWidgetOpener() {
    const [widgetReady, setWidgetReady] = useState(false);
    const intervalId = useRef(null);
    useEffect(() => {
        const checkWidgetExistence = () => {
            if (document.querySelector(`#${WIDGET_ID}`) !== null) {
                setWidgetReady(true);
                clearInterval(intervalId.current);
            }
        };
        intervalId.current = setInterval(checkWidgetExistence, 1000);
    }, []);
    const openWidget = useCallback(() => {
        if (widgetReady) {
            const event = new CustomEvent('openWidget');
            document.dispatchEvent(event);
        }
    }, [widgetReady]);
    return { widgetReady, openWidget };
}
